import 'bootstrap/dist/css/bootstrap.css'
import 'react-toastify/dist/ReactToastify.css';
import "react-quill/dist/quill.snow.css";
import 'react-datepicker/dist/react-datepicker.css';
import "react-international-phone/style.css";
import './App.scss';
import Navigation from './navigation';
import { ToastContainer } from 'react-toastify';
const App = () => {
  return (
    <>
      <div className="App">
        <Navigation />
        <ToastContainer />
        {/* <ToastContainer transition={Flip} enableMultiContainer={false} limit={1}
        /> */}
      </div>

    </>
  );
};
export default App;
